module.exports = __webpack_public_path__ + "img/w3_circle_bars_black.9b9d519d.png";